import { css } from '@emotion/core';

import { SPACE_TINY } from '@/styles';

export const configurationPanelStyles = css`
  font-size: 13px;
  padding: ${SPACE_TINY}px;
`;
